import React, { MouseEventHandler, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { Listings } from 'containers/AppContainer/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { translate } from 'containers/services/translate';
import { StyledJudgementAddPronouncingRecap } from 'containers/common/LegalProceedings/JudgementAdd/Recap/styled-component';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';

import SahamAccordion from 'components/SahamAccordion';
import JudgementAddPronouncingRecap from 'containers/LawyerLegalProceedingsPage/AppealAdd/Recap/AppealAddRecap';
import { showValidator } from 'containers/common/LegalProceedings/utils';
import { get, isEmpty } from 'lodash';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import { toBeEdited } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import {
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';

export interface JudgementAddPronouncingRecapAccordionProps {
  intl: IntlShape;
  listings: Listings;
  judgementAddDocument: JudgementADDDocumentType;
  index: number;
  deleteJudgementAdd?: MouseEventHandler;
  editJudgementAdd?: MouseEventHandler;
  readOnly?: boolean;
  isManager: boolean;
  judgementAdd?: any;
  claimNumber?: string;
  setJudgementAdd?: Function;
  requestMakeJudgementAddDocumentDecision?: Function;
  requestUpdateJudgementAddDocument?: Function;
  isSaved?: boolean;
  judiciaryProcessId?: number;
  setDialogOpenFirmReference?: Function;
  isAssignedLawyer?: boolean;
  requestGetJudgementAdd?: Function;
  judgementAddDocumentIds?: any;
  expertReport?: ExpertReportType;
  judgementOnMerits?: JudgementOnMeritsType;
  handleIsDialogOpen?: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  claimAssignment: any;
  feeNotes: any;
  setOpenFeeNoteDialog: Function;
  isConsultation: Boolean;
  policyInfo: any;
  requestGetDocByDocumentumId: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setOpenInvoiceFeeNoteUpdateInfoDialog: Function;
  openInvoiceFeeNoteUpdateInfoDialog: boolean;
  setDocumentId: Function;
  handleValidateUpdateJudgementAddDocument: Function;
  setJudgemenAddDocumentToUpdate: Function;
}

const JudgementAddPronouncingRecapAccordion: React.FC<JudgementAddPronouncingRecapAccordionProps> = (
  props,
): JSX.Element => {
  const [expanded, setExpanded] = useState<boolean>(true);
  const handleChangeOnExpand = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    event.stopPropagation();
    setExpanded(expanded);
  };
  const appealADDDocumentValidator = showValidator(
    get(props, 'judgementAddDocument.validator', ''),
    props.isManager,
  );
  const appealADDValidator =
    showValidator(get(props, 'judgementAdd.validator', ''), props.isManager) &&
    isEmpty(get(props, 'judgementAddDocument.status'));

  const decidedBy = (
    <section className="section">
      <article>
        {translate(messages.arret, props, { index: props.index + 1 })}
      </article>
      {props.isSaved &&
        (props.isAssignedLawyer || props.isManager) &&
        get(props.judgementAddDocument, 'uploadedBy', '') && (
          <ValidatorRecap
            validator={get(props.judgementAddDocument, 'uploadedBy', '')}
            customTitle={translate(messages.creatorTitleMultiple, props)}
          />
        )}
      {appealADDDocumentValidator && (
        <ValidatorRecap
          validator={get(props.judgementAddDocument, 'validator', '')}
        />
      )}
      {appealADDValidator && (
        <ValidatorRecap validator={get(props.judgementAdd, 'validator', '')} />
      )}
    </section>
  );

  const { deleteJudgementAdd, editJudgementAdd } = props;
  const isCreator = props.isManager
    ? true
    : get(props.judgementAddDocument, 'uploadedBy') ===
      currentIntervenantStorage.get()?.preferred_username;
  return (
    <StyledJudgementAddPronouncingRecap>
      <SahamAccordion
        title={decidedBy}
        deleteButtonTitle={translate(messages.deleteJudgement, props)}
        expanded={expanded}
        onChange={handleChangeOnExpand}
        deleteButtonOnClick={deleteJudgementAdd}
        editButtonTitle={translate(messages.editJudgement, props)}
        editButtonOnClick={editJudgementAdd}
        accordionDetailsClassName="content-wrapper"
        readOnly={
          ![
            !props.readOnly,
            isCreator &&
              toBeEdited(props.judgementAddDocument, props.isManager),
          ].some(item => item)
        }
      >
        <JudgementAddPronouncingRecap
          judgementAddDocument={props.judgementAddDocument}
          listings={props.listings}
          judgementAdd={props.judgementAdd}
          isManager={props.isManager}
          claimNumber={props.claimNumber}
          requestMakeJudgementAddDocumentDecision={
            props.requestMakeJudgementAddDocumentDecision
          }
          requestUpdateJudgementAddDocument={
            props.requestUpdateJudgementAddDocument
          }
          setJudgementAdd={props.setJudgementAdd}
          judiciaryProcessId={props.judiciaryProcessId}
          setDialogOpenFirmReference={props.setDialogOpenFirmReference}
          requestGetJudgementAdd={props.requestGetJudgementAdd}
          judgementAddDocumentIds={props.judgementAddDocumentIds}
          expertReport={props.expertReport}
          judgementOnMerits={props.judgementOnMerits}
          handleCivilPartyDialog={props.handleIsDialogOpen}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          claimAssignment={props.claimAssignment}
          feeNotes={props.feeNotes}
          setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
          isConsultation={props.isConsultation}
          policyInfo={props.policyInfo}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          openInvoiceFeeNoteUpdateInfoDialog={
            props.openInvoiceFeeNoteUpdateInfoDialog
          }
          setOpenInvoiceFeeNoteUpdateInfoDialog={
            props.setOpenInvoiceFeeNoteUpdateInfoDialog
          }
          setDocumentId={props.setDocumentId}
          handleValidateUpdateJudgementAddDocument={
            props.handleValidateUpdateJudgementAddDocument
          }
          setJudgemenAddDocumentToUpdate={props.setJudgemenAddDocumentToUpdate}
        />
      </SahamAccordion>
    </StyledJudgementAddPronouncingRecap>
  );
};

export default injectIntl(JudgementAddPronouncingRecapAccordion);
